import type { Creator } from '@/types';
import {
  madridFirstOfMonth,
  madridMonday,
  madridStartOfDay,
  madridToday,
} from './madrid-date';

export type TimePeriod = 'today' | 'week' | 'month' | 'total';

function getPeriodStart(period: TimePeriod): Date | null {
  if (period === 'total') return null;
  if (period === 'today') return madridStartOfDay(madridToday());
  if (period === 'week') return madridStartOfDay(madridMonday());
  return madridStartOfDay(madridFirstOfMonth());
}

export function filterByPeriod(
  creators: Creator[],
  period: TimePeriod
): Creator[] {
  const start = getPeriodStart(period);
  if (!start) return creators;
  return creators.filter((l) => new Date(l.created) >= start);
}

export function countLeadsToday(creators: Creator[]): number {
  const start = madridStartOfDay(madridToday());
  return creators.filter((l) => new Date(l.created) >= start).length;
}
